import { apiClient } from '../config';
import { endpoints } from '../endpoints';

/**
 * Title service for handling user title operations
 */
export const titleService = {
  /**
   * Get all titles
   * @returns {Promise<Array>} - Promise resolving to array of titles
   */
  getAllTitles: async () => {
    const response = await apiClient.get(endpoints.titles.getAll);
    return response.data;
  },

  /**
   * Get active titles
   * @returns {Promise<Array>} - Promise resolving to array of active titles
   */
  getActiveTitles: async () => {
    const response = await apiClient.get(endpoints.titles.getActive);
    return response.data;
  },

  /**
   * Get title by ID
   * @param {string} id - Title ID
   * @returns {Promise<Object>} - Promise resolving to title data
   */
  getTitleById: async (id) => {
    const response = await apiClient.get(`${endpoints.titles.getById(id)}`);
    return response.data;
  },

  /**
   * Create a new title
   * @param {Object} titleData - Title data
   * @param {string} titleData.name - Title name
   * @param {string} [titleData.shortName] - Title short name
   * @returns {Promise<Object>} - Promise resolving to created title
   */
  createTitle: async (titleData) => {
    const response = await apiClient.post(endpoints.titles.create, titleData);
    return response.data;
  },

  /**
   * Update an existing title
   * @param {string} id - Title ID
   * @param {Object} titleData - Title data to update
   * @param {string} [titleData.name] - Title name
   * @param {string} [titleData.shortName] - Title short name
   * @param {boolean} [titleData.isActive] - Whether the title is active
   * @returns {Promise<Object>} - Promise resolving to updated title
   */
  updateTitle: async (id, titleData) => {
    const response = await apiClient.put(`${endpoints.titles.update(id)}`, titleData);
    return response.data;
  },

  /**
   * Delete a title
   * @param {string} id - Title ID
   * @returns {Promise<Object>} - Promise resolving to success message
   */
  deleteTitle: async (id) => {
    const response = await apiClient.delete(`${endpoints.titles.delete(id)}`);
    return response.data;
  }
};
